import styled from 'styled-components/macro';

import CustomPopoverBase from '@components/common/core/Utils/CustomPopover';
import TextBase from '@components/common/core/DataDisplay/Text';

export const PopoverArrow = styled(CustomPopoverBase.Arrow)`
  fill: ${({ theme }) => theme.colors.black.light};
`;

export const PopoverContent = styled(CustomPopoverBase.Content)`
  background-color: ${({ theme }) => theme.colors.black.light};
  border-radius: 10px;
  box-sizing: border-box;
  padding: 22px 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  min-width: 258px;
  gap: 20px;
`;

export const ActionButton = styled.button`
  background-color: unset;
  border: unset;
  width: 100%;
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.font};
  text-align: left;
  line-height: 120%;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.green.default};
  }

  &:active {
    color: ${({ theme }) => theme.colors.green.dark};
  }
`;

export const PlanName = styled(TextBase)`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.green.default};
`;

export const Text = styled(TextBase)`
  display: inline-block;
  margin-bottom: 42px;
  text-align: center;
`;

export const ButtonTrigger = styled(CustomPopoverBase.Trigger)`
  background-color: unset;
  border: 1px solid ${({ theme }) => theme.colors.gray[2]};
  border-radius: 5px;
  height: 32px;
  padding: 7px 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.font};
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    filter: brightness(0.9);
  }
`;

export const Popover = styled(CustomPopoverBase)``;
